import {
  GreyGrey100,
  Spinner as SpinnerComponent,
  Flex
} from '@sequencehq/core-components'
import { FC } from 'react'

const Spinner: FC<{
  height?: string
  width?: string
  color?: string
}> = ({ height, width, color = GreyGrey100 }) => (
  <Flex
    width={width ?? '100%'}
    height={height ?? '100%'}
    display="flex"
    justifyContent="center"
    alignItems="center"
  >
    <SpinnerComponent width={width} height={height} color={color} />
  </Flex>
)

export default Spinner
